export default __webpack_public_path__ + "static/media/one-third-global-greenhouse-gas-emissions-from-food.6d209ed5.png";